(function () {
  var V6_JS_MARKER = "ag1-pdp-v6.js";
  var V6_CSS_MARKER = "ag1-pdp-v6.css";
  var ONETIME_DRAWBACKS_HTML = "<ul><li>$9 shipping ▾</li></ul>";
  var FREQ_ARROW_CUSTOM_CSS =
    "/* One-time drawbacks chevron (same slot as $9 shipping) */" +
    ".ag1-onetime-arrow,rc-onetime-drawbacks .ag1-onetime-arrow,[class*=onetime-drawback] .ag1-onetime-arrow{" +
    "display:inline-block!important;width:.45rem!important;height:.45rem!important;" +
    "margin-left:.4rem!important;vertical-align:middle!important;" +
    "border-right:2px solid currentColor!important;border-bottom:2px solid currentColor!important;" +
    "transform:rotate(45deg) translateY(-0.1rem)!important}" +
    "/* Frequency button chevron (optional) */" +
    ".ag1-rc-freq-trigger,.rc-purchase-option button,[class*=frequency] button,[class*=Frequency] button," +
    "[class*=selling-plan] button{position:relative!important;padding-right:2.6rem!important}" +
    ".ag1-rc-freq-trigger::after,.rc-purchase-option button::after,[class*=frequency] button::after," +
    "[class*=Frequency] button::after,[class*=selling-plan] button::after{" +
    "content:\"\"!important;position:absolute!important;right:1.05rem!important;top:50%!important;" +
    "width:.55rem!important;height:.55rem!important;margin-top:-.28rem!important;" +
    "border-right:2px solid currentColor!important;border-bottom:2px solid currentColor!important;" +
    "transform:rotate(45deg)!important;pointer-events:none!important;display:block!important}";

  // Recharge only expands One-time when settings.onetimeDrawbacks is non-empty.
  // Patch merchant config before the widget boots (and keep it patched if it reloads).
  function applyOnetimeDrawbacksToConfigObject(node) {
    if (!node || typeof node !== "object") {
      return false;
    }
    var cfg = node.preview_config && typeof node.preview_config === "object"
      ? node.preview_config
      : node;
    if (!cfg || typeof cfg !== "object") {
      return false;
    }
    if (!("onetimeDrawbacks" in cfg) && !("badgeText" in cfg) && !("benefits" in cfg)) {
      return false;
    }
    if (cfg.onetimeDrawbacks !== ONETIME_DRAWBACKS_HTML) {
      cfg.onetimeDrawbacks = ONETIME_DRAWBACKS_HTML;
    }
    // Frequency dropdown chevron via Recharge customCSS (applies inside widget).
    if (typeof cfg.customCSS === "string" && cfg.customCSS.indexOf("ag1-rc-freq") === -1) {
      cfg.customCSS = (cfg.customCSS || "") + "\n/* ag1-rc-freq */\n" + FREQ_ARROW_CUSTOM_CSS;
    }
    return true;
  }

  function patchSubscriptionWidgetConfig() {
    var root = window.SubscriptionWidgetConfig;
    if (!root || typeof root !== "object") {
      return false;
    }
    var patched = false;
    Object.keys(root).forEach(function (key) {
      if (applyOnetimeDrawbacksToConfigObject(root[key])) {
        patched = true;
      }
    });
    return patched;
  }

  function installSubscriptionWidgetConfigHook() {
    if (window.__ag1RcOnetimeHook) {
      return;
    }
    // This file is also loaded from <head>, before <body> exists. Wait so the
    // Queen’s skip below can see the template class and not start a 25ms poll.
    if (!document.body) {
      document.addEventListener("DOMContentLoaded", installSubscriptionWidgetConfigHook);
      return;
    }
    // Queen↔Bundle upsell / custom buy boxes hide Recharge — skip 25ms poll (mobile jank)
    var bc = (document.body && document.body.className) || "";
    if (
      bc.indexOf("hm-queens-bundle-upsell") !== -1 ||
      bc.indexOf("hm-ag1-queens-upsell") !== -1
    ) {
      return;
    }
    window.__ag1RcOnetimeHook = true;
    var existing = window.SubscriptionWidgetConfig;
    if (!existing || typeof existing !== "object") {
      existing = {};
      window.SubscriptionWidgetConfig = existing;
    }
    patchSubscriptionWidgetConfig();
    try {
      var desc = Object.getOwnPropertyDescriptor(existing, "preview_config");
      if (!desc || desc.configurable) {
        var stored = existing.preview_config;
        Object.defineProperty(existing, "preview_config", {
          configurable: true,
          enumerable: true,
          get: function () {
            return stored;
          },
          set: function (value) {
            stored = value;
            applyOnetimeDrawbacksToConfigObject(value);
          },
        });
        if (stored) {
          applyOnetimeDrawbacksToConfigObject(stored);
        }
      }
    } catch (err) {
      // Ignore if Recharge already locked the object.
    }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (patchSubscriptionWidgetConfig() || tries > 200) {
        window.clearInterval(timer);
      }
    }, 25);
  }

  installSubscriptionWidgetConfigHook();

  function loadAg1V6Css(jsSrc) {
    if (document.getElementById("ag1-pdp-v6-css")) {
      return;
    }
    var href = jsSrc.replace(/\.js(\?.*)?$/, ".css");
    var link = document.createElement("link");
    link.id = "ag1-pdp-v6-css";
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  }

  var bodyClass = document.body && document.body.className;
  if (
    !bodyClass ||
    (bodyClass.indexOf("ag1-v1") === -1 &&
      bodyClass.indexOf("ag1-v2") === -1 &&
      bodyClass.indexOf("ag1-v3") === -1 &&
      bodyClass.indexOf("ag1-v4") === -1 &&
      bodyClass.indexOf("ag1-v5") === -1)
  ) {
    return;
  }

  // Versioned so a newer build can still run if an older copy already set a boolean flag.
  var AG1_PDP_V6_BUILD = "20260729-freq-arrow-2";
  if (window.__ag1PdpV6Init === AG1_PDP_V6_BUILD) {
    return;
  }
  window.__ag1PdpV6Init = AG1_PDP_V6_BUILD;

  var scripts = document.querySelectorAll('script[src*="' + V6_JS_MARKER + '"]');
  if (scripts.length) {
    loadAg1V6Css(scripts[scripts.length - 1].src);
  }

  function loadAg1GalleryCss() {
    if (document.getElementById("ag1-pdp-gallery-css")) {
      return;
    }
    var link = document.createElement("link");
    link.id = "ag1-pdp-gallery-css";
    link.rel = "stylesheet";
    var base = "";
    var v6Script = document.querySelector('script[src*="ag1-pdp-v6.js"]');
    if (v6Script && v6Script.src) {
      base = v6Script.src.replace(/ag1-pdp-v6\.js.*$/, "");
    }
    link.href = base
      ? base + "ag1-pdp-gallery-v2.css"
      : "https://cdn.shopify.com/s/files/1/0722/0019/2155/t/10/assets/ag1-pdp-gallery-v2.css";
    document.head.appendChild(link);
  }

  function layoutAg1Gallery() {
    var gallery = document.querySelector(
      "body[class*='ag1-v'] [data-product-holder] .gallery.gallery__default, body[class*='ag1-v'] [data-product-holder] .gallery"
    );
    if (!gallery) {
      return;
    }

    document
      .querySelectorAll("[data-product-holder] .gallery__vertical")
      .forEach(function (node) {
        node.style.setProperty("display", "none", "important");
      });

    var thumbs = gallery.querySelector(".gallery__thumbnails");
    var slider = gallery.querySelector(".slider--product__holder");
    if (
      thumbs &&
      slider &&
      thumbs.compareDocumentPosition(slider) & Node.DOCUMENT_POSITION_FOLLOWING
    ) {
      gallery.appendChild(thumbs);
    }

    gallery.style.setProperty("display", "flex", "important");
    gallery.style.setProperty("flex-direction", "column", "important");
    gallery.style.setProperty("flex-wrap", "nowrap", "important");
    gallery.style.setProperty("max-height", "none", "important");
    gallery.style.setProperty("width", "100%", "important");

    if (slider) {
      slider.style.setProperty("order", "1", "important");
      slider.style.setProperty("width", "100%", "important");
      slider.style.setProperty("max-height", "none", "important");
    }

    if (thumbs) {
      thumbs.style.setProperty("order", "2", "important");
      thumbs.style.setProperty("display", "flex", "important");
      thumbs.style.setProperty("flex-direction", "row", "important");
      thumbs.style.setProperty("flex-wrap", "nowrap", "important");
      thumbs.style.setProperty("width", "100%", "important");
      thumbs.style.setProperty("max-height", "none", "important");
      thumbs.style.setProperty("height", "auto", "important");
      thumbs.style.setProperty("overflow-x", "auto", "important");
      thumbs.style.setProperty("overflow-y", "hidden", "important");
      thumbs.style.setProperty("transform", "none", "important");
      thumbs.style.setProperty("margin", "0.75rem 0 0", "important");
      thumbs.style.setProperty("padding", "0", "important");
      thumbs.style.setProperty("gap", "0.35rem", "important");
      thumbs.querySelectorAll(".gallery__thumbnail").forEach(function (thumb) {
        thumb.style.setProperty("width", "72px", "important");
        thumb.style.setProperty("height", "72px", "important");
        thumb.style.setProperty("flex", "0 0 auto", "important");
        thumb.style.setProperty("margin", "0", "important");
      });
    }
  }

  loadAg1GalleryCss();

  function redirectStaleAg1V1Cache() {
    var match = bodyClass.match(/template--product\.ag1-v1-([a-z0-9-]+)/);
    if (!match || window.location.search.indexOf("view=") !== -1) {
      return;
    }
    var suffix = match[1];
    var target = "ag1-v5-" + suffix;
    if (suffix.indexOf("queens") !== -1) {
      target = "queens-bundle-upsell";
    }
    window.location.replace(
      window.location.pathname + "?view=" + target + window.location.hash
    );
  }

  function removeStaleInlineAg1Css() {
    document.querySelectorAll("style").forEach(function (el) {
      var text = el.textContent || "";
      if (
        text.indexOf("[data-product-holder]") !== -1 &&
        text.indexOf("gallery__vertical.hide-mobile") !== -1 &&
        (text.indexOf("padding: 0 32px") !== -1 ||
          text.indexOf("ag1-pdp-includes") !== -1 ||
          text.indexOf("accordion__item--content") !== -1)
      ) {
        el.remove();
      }
    });
  }

  function hideSubscriptionConsent() {
    var buyBox =
      document.querySelector(".product__page--info .product__atc") ||
      document.querySelector(".product__page--info");
    if (!buyBox) {
      return;
    }

    buyBox
      .querySelectorAll(
        '#shopify-buyer-consent, small#shopify-buyer-consent, [data-consent-type="subscription"]'
      )
      .forEach(function (node) {
        node.style.setProperty("display", "none", "important");
        node.style.setProperty("visibility", "hidden", "important");
        node.style.setProperty("height", "0", "important");
        node.style.setProperty("margin", "0", "important");
        node.style.setProperty("padding", "0", "important");
        node.style.setProperty("overflow", "hidden", "important");
      });

    buyBox.querySelectorAll("small, p, label").forEach(function (node) {
      if (node.children.length > 0) {
        return;
      }
      var text = (node.textContent || "").toLowerCase();
      if (
        text.indexOf("deferred") !== -1 &&
        text.indexOf("subscription") !== -1 &&
        text.indexOf("cancel") !== -1
      ) {
        node.style.setProperty("display", "none", "important");
      }
    });
  }

  function normalizeIncludesLines() {
    document.querySelectorAll(".product__urgency.ag1-pdp-includes p").forEach(function (p) {
      var text = (p.textContent || "").replace(/^\s*[✓✔]\s*/, "").trim();
      if (text && text !== p.textContent) {
        p.textContent = text;
      }
    });
  }

  function normalizeSummaryBullets() {
    // Queen↔Bundle upsell: three equal benefit bullets — never promote to eyebrow/tagline
    if (
      document.body.classList.contains("hm-queens-bundle-upsell") ||
      document.body.classList.contains("hm-ag1-queens-upsell")
    ) {
      document.querySelectorAll(".product__urgency.ag1-pdp-summary p").forEach(function (p) {
        p.classList.remove("ag1-pdp-descriptor", "ag1-pdp-summary-tagline");
      });
      return;
    }
    document.querySelectorAll(".product__urgency.ag1-pdp-summary p").forEach(function (p) {
      var html = p.innerHTML || "";
      var cleaned = html.replace(/\*(?=\s*<\/)/gi, "").replace(/\*$/g, "");
      if (cleaned !== html) {
        p.innerHTML = cleaned;
      }
      if (/Daily Creatine Adaptogen Blend/i.test(p.textContent || "")) {
        p.classList.add("ag1-pdp-descriptor");
        p.classList.remove("ag1-pdp-summary-tagline");
        return;
      }
      if (/One checkout\. One subscription/i.test(p.textContent || "")) {
        p.classList.add("ag1-pdp-summary-tagline");
        return;
      }
      if (
        p.classList.contains("ag1-pdp-summary-tagline") ||
        /Creatine Monohydrate|Ashwagandha \(KSM-66|Prebiotic Fiber|Creatine|KSM-66|FiberSmart|zero sugar/i.test(
          p.textContent || ""
        )
      ) {
        p.classList.add("ag1-pdp-summary-tagline");
      }
    });
  }

  function tagAg1DeliveryBlocks() {
    document.querySelectorAll(".product__urgency").forEach(function (el) {
      if (el.classList.contains("ag1-pdp-includes") || el.classList.contains("ag1-pdp-summary")) {
        return;
      }
      var text = el.textContent || "";
      if (text.indexOf("Your subscription includes:") !== -1) {
        el.classList.add("ag1-pdp-includes");
      } else if (
        el.closest(".product__page--info") &&
        (text.indexOf("Enhances muscle") !== -1 ||
          text.indexOf("Steadies appetite") !== -1 ||
          text.indexOf("Creatine") !== -1)
      ) {
        el.classList.add("ag1-pdp-summary");
      }
    });
  }

  function applyAg1FallbackStyles() {
    tagAg1DeliveryBlocks();
    normalizeIncludesLines();
    normalizeSummaryBullets();
    document.querySelectorAll(".product__urgency.ag1-pdp-includes").forEach(function (el) {
      el.style.setProperty("background", "#f3f0ed", "important");
      el.style.setProperty("border", "1px solid #e3d9d2", "important");
      el.style.setProperty("border-radius", "12px", "important");
      el.style.setProperty("padding", "0.85rem 1.15rem 1rem", "important");
    });

    document
      .querySelectorAll(
        ".product__accordion .accordion__item--content, .product__accordion .accordion__content"
      )
      .forEach(function (el) {
        el.style.setProperty("background", "transparent", "important");
        el.style.setProperty("background-color", "transparent", "important");
      });
  }

  function collectShadowRoots(node, roots) {
    if (!node) {
      return;
    }
    if (node.shadowRoot) {
      roots.push(node.shadowRoot);
      collectShadowRoots(node.shadowRoot, roots);
    }
    if (!node.querySelectorAll) {
      return;
    }
    node.querySelectorAll("*").forEach(function (el) {
      if (el.shadowRoot) {
        roots.push(el.shadowRoot);
        collectShadowRoots(el.shadowRoot, roots);
      }
    });
  }

  function getRechargeWidgetRoots() {
    var hosts = document.querySelectorAll(
      ".recharge-subscription-widget, recharge-subscription-widget, [class*='recharge-subscription']"
    );
    var roots = [];
    Array.prototype.forEach.call(hosts, function (host) {
      roots.push(host);
      collectShadowRoots(host, roots);
    });
    // Fallback: any custom element that looks like Recharge purchase UI.
    document.querySelectorAll("rc-purchase-option, rc-subscription-widget, [class*='rc-purchase']").forEach(function (el) {
      roots.push(el);
      collectShadowRoots(el, roots);
    });
    return roots;
  }

  var FREQ_ARROW_CSS =
    ".ag1-rc-freq-trigger{position:relative!important;padding-right:2.6rem!important;box-sizing:border-box!important;}" +
    ".ag1-rc-freq-arrow{position:absolute!important;right:1.05rem!important;top:50%!important;" +
    "width:0.55rem!important;height:0.55rem!important;margin-top:-0.28rem!important;" +
    "border-right:2px solid currentColor!important;border-bottom:2px solid currentColor!important;" +
    "transform:rotate(45deg)!important;pointer-events:none!important;display:block!important;opacity:0.95!important;}";

  function ensureFreqArrowStyles(root) {
    if (!root || !root.appendChild) {
      return;
    }
    if (root.querySelector && root.querySelector("style[data-ag1-freq-arrow]")) {
      return;
    }
    var style = document.createElement("style");
    style.setAttribute("data-ag1-freq-arrow", "1");
    style.textContent = FREQ_ARROW_CSS;
    root.appendChild(style);
  }

  function ensureFrequencyDropdownArrow() {
    getRechargeWidgetRoots().forEach(function (root) {
      if (!root.querySelectorAll) {
        return;
      }
      ensureFreqArrowStyles(root);

      var candidates = root.querySelectorAll(
        "button, [role='button'], [class*='frequency'] button, [class*='Frequency'] button, select, div[tabindex]"
      );
      Array.prototype.forEach.call(candidates, function (el) {
        var text = (el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        if (text.length > 80) {
          return;
        }
        // Deliver-every pill: "1 month" / "save 15.19%"
        if (!/\b\d+\s*(month|week|day)s?\b/.test(text) && text.indexOf("month") === -1) {
          return;
        }
        if (!/\b(month|week|day)s?\b/.test(text)) {
          return;
        }
        if (text.indexOf("subscribe") !== -1 || text.indexOf("one-time") !== -1) {
          return;
        }

        el.classList.add("ag1-rc-freq-trigger");
        el.style.setProperty("position", "relative", "important");
        el.style.setProperty("padding-right", "2.6rem", "important");
        if (el.tagName === "SELECT") {
          el.style.setProperty("appearance", "none", "important");
          el.style.setProperty("-webkit-appearance", "none", "important");
        }
        if (el.querySelector && el.querySelector(".ag1-rc-freq-arrow")) {
          return;
        }
        var arrow = document.createElement("span");
        arrow.className = "ag1-rc-freq-arrow";
        arrow.setAttribute("aria-hidden", "true");
        el.appendChild(arrow);
      });
    });
  }

  function stackRechargeBenefits() {
    getRechargeWidgetRoots().forEach(function (widget) {
      if (!widget.querySelectorAll) {
        return;
      }
      widget.querySelectorAll("ul, ol").forEach(function (container) {
        if (!container.children.length) {
          return;
        }
        container.style.setProperty("display", "block", "important");
        container.style.setProperty("flex-direction", "column", "important");
        container.style.removeProperty("flex-wrap");
        container.style.setProperty("gap", "0.2rem", "important");
        container.style.setProperty("list-style", "none", "important");
        container.style.setProperty("margin", "0.35rem 0 0", "important");
        container.style.setProperty("padding", "0", "important");
        Array.prototype.forEach.call(container.children, function (child) {
          child.style.setProperty("display", "list-item", "important");
          child.style.setProperty("width", "100%", "important");
          child.style.setProperty("margin", "0 0 0.15rem", "important");
        });
      });

      // Native Recharge onetime drawbacks often sit inline in the label row — force full-width stack.
      widget
        .querySelectorAll(
          "rc-onetime-drawbacks, .rc-onetime-drawbacks, [class*='onetime-drawback'], [id='rc-drawbacks']"
        )
        .forEach(function (el) {
          el.style.setProperty("display", "block", "important");
          el.style.setProperty("width", "100%", "important");
          el.style.setProperty("flex-basis", "100%", "important");
          el.style.setProperty("margin", "0.35rem 0 0", "important");
        });
    });
  }

  function ensureOneTimeShippingNote() {
    getRechargeWidgetRoots().forEach(function (root) {
      if (!root.querySelectorAll) {
        return;
      }
      var cards = root.querySelectorAll(
        ".rc-purchase-option__onetime, .rc-selection__onetime, .rc-onetime, [class*='purchase-option__onetime']"
      );
      var cardList = Array.prototype.slice.call(cards);
      if (!cardList.length) {
        root.querySelectorAll(".rc-purchase-option, [class*='purchase-option']").forEach(function (el) {
          var label = el.querySelector(".rc-purchase-option__label, label");
          var text = ((label && label.textContent) || el.textContent || "")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();
          if (
            (text.indexOf("one-time") !== -1 || text.indexOf("one time") !== -1) &&
            text.indexOf("subscribe") === -1
          ) {
            cardList.push(el);
          }
        });
      }

      cardList.forEach(function (card) {
        card.classList.add("ag1-onetime-card");
        card.style.setProperty("flex-wrap", "wrap", "important");

        var nativeDrawback = card.querySelector(
          "rc-onetime-drawbacks, .rc-onetime-drawbacks, [class*='onetime-drawback'], #rc-drawbacks"
        );
        if (nativeDrawback) {
          // Prefer Recharge's native drawbacks slot; keep our inject out of the way.
          var legacy = card.querySelector(".ag1-onetime-shipping");
          if (legacy) {
            legacy.style.display = "none";
          }
          return;
        }

        var sub =
          card.querySelector(".rc-purchase-option__sub-container") || card;
        var note = card.querySelector(".ag1-onetime-shipping");
        if (!note) {
          note = document.createElement("div");
          note.className = "ag1-onetime-shipping";
          note.innerHTML =
            '<ul class="ag1-onetime-shipping__list"><li>$9 shipping ▾</li></ul>';
          sub.appendChild(note);
        } else {
          var li = note.querySelector("li");
          if (li && li.textContent.indexOf("$9 shipping") === -1) {
            li.textContent = "$9 shipping ▾";
          } else if (li && li.textContent.indexOf("▾") === -1) {
            li.textContent = "$9 shipping ▾";
          }
        }

        var input = card.querySelector(
          "input.rc-purchase-option__input, input[type='radio'], input[value='onetime'], input[value='one-time']"
        );
        var selected =
          card.classList.contains("rc-purchase-option__selected") ||
          (input && input.checked) ||
          card.getAttribute("aria-checked") === "true";

        if (!selected && root.querySelector) {
          var checked = root.querySelector(
            ".rc-purchase-option__onetime input:checked, .rc-selection__onetime input:checked, input[value='onetime']:checked"
          );
          if (
            checked &&
            (card.contains(checked) ||
              card.classList.contains("rc-purchase-option__onetime") ||
              card.classList.contains("rc-selection__onetime"))
          ) {
            selected = true;
          }
        }

        card.classList.toggle("ag1-onetime-card--open", !!selected);
        note.style.display = selected ? "block" : "none";
      });
    });
  }

  function enhanceRechargeWidget() {
    stackRechargeBenefits();
    ensureOneTimeShippingNote();
    ensureFrequencyDropdownArrow();
  }

  function roundShopPayButtons() {
    document
      .querySelectorAll(
        ".shopify-payment-button, .shopify-payment-button__button, shop-pay-button, shop-pay-wallet-button"
      )
      .forEach(function (node) {
        node.style.borderRadius = "10px";
        node.style.overflow = "hidden";
      });
  }

  function runAg1Fixes() {
    removeStaleInlineAg1Css();
    layoutAg1Gallery();
    hideSubscriptionConsent();
    applyAg1FallbackStyles();
    enhanceRechargeWidget();
    roundShopPayButtons();
  }

  removeStaleInlineAg1Css();
  layoutAg1Gallery();
  redirectStaleAg1V1Cache();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runAg1Fixes);
  } else {
    runAg1Fixes();
  }
  window.setTimeout(runAg1Fixes, 400);
  window.setTimeout(runAg1Fixes, 1200);
  window.setTimeout(runAg1Fixes, 2500);

  // Recharge widget hydrates async (often inside open shadow roots).
  var rechargeHost =
    document.querySelector(".product__page--info") || document.body;
  if (rechargeHost && window.MutationObserver) {
    var rechargeTimer = null;
    var observer = new MutationObserver(function () {
      if (rechargeTimer) {
        window.clearTimeout(rechargeTimer);
      }
      rechargeTimer = window.setTimeout(enhanceRechargeWidget, 80);
    });
    observer.observe(rechargeHost, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function isRechargePurchaseToggle(target) {
    if (!target) {
      return false;
    }
    if (target.closest) {
      if (
        target.closest(".recharge-subscription-widget") ||
        target.closest("recharge-subscription-widget") ||
        target.closest(".rc-purchase-option") ||
        target.closest("[class*='rc-purchase-option']")
      ) {
        return true;
      }
    }
    var name = (target.getAttribute && target.getAttribute("name")) || "";
    var val = (target.getAttribute && target.getAttribute("value")) || "";
    return (
      /purchase|selling|recharge|subscription/i.test(name) ||
      /onetime|one-time|subscription/i.test(val)
    );
  }

  document.addEventListener(
    "change",
    function (event) {
      if (!isRechargePurchaseToggle(event.target)) {
        return;
      }
      window.setTimeout(enhanceRechargeWidget, 50);
    },
    true
  );
  document.addEventListener(
    "click",
    function (event) {
      if (!isRechargePurchaseToggle(event.target)) {
        return;
      }
      window.setTimeout(enhanceRechargeWidget, 50);
    },
    true
  );

  document.addEventListener("click", function (event) {
    var title = event.target.closest(".product__accordion .accordion__item--title");
    if (!title) {
      return;
    }

    var item = title.closest(".accordion__item");
    var wrapper = title.closest(".product__accordion");
    if (!item || !wrapper) {
      return;
    }

    var openInput = item.querySelector('input[type="radio"]');
    var closeInput = wrapper.querySelector('input[type="radio"][id$="--close"]');
    if (!openInput || !closeInput) {
      return;
    }

    if (openInput.checked) {
      event.preventDefault();
      closeInput.checked = true;
    }
  });
})();
